import Spline from '@splinetool/react-spline';
import  NavbarPrices  from "./NavbarPrices";


export const Design = () => {
  return (
    <div className=''>
      <img src='https://i.ibb.co/wYKTvwD/crm.jpg'></img>
      
    </div>
  );
}